var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
        _vm.type ?'s-button-'+_vm.type:'s-button',
        {
            'is-disabled': _vm.isDisable,
            'is-fillet':_vm.isFillet,
            'is-hollow':_vm.isHollow
        }
    ],style:(_vm.colorBox),attrs:{"disabled":_vm.isDisable},on:{"click":_vm.handleClick}},[(_vm.left)?_c('i',{staticClass:"iconfont",class:_vm.icon}):_vm._e(),_vm._t("default"),(!_vm.left)?_c('i',{staticClass:"iconfont",class:_vm.icon}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }